<template>
  <b-row>
    <b-col md="12">
        <b-alert v-for="(errors, id) in response.errors" :key="id" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
            <p v-if="response.errors" style="font-size:13px;margin-bottom: 0;"><b>{{ id }}</b> : <span v-for="(error, index) in errors" :key="index"><br>{{ error }}</span></p>
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-alert v-if="!response.errors" :show="dismissCountDown"
                  dismissible
                  :variant="response.success== true ? 'success':'danger'"
                  @dismissed="dismissCountdown=0"
                  @dismiss-count-down="countDownChanged">
           <strong v-if="!response.errors">{{response.message}}</strong>
        </b-alert>
        <b-card>
          <div slot="header">
             Ajout des <strong>Approvisionnements / Guichets</strong>  
          </div>
          <b-row class="form-group">
            <b-col md="6">
              <label for="device">Montant (*)</label>
              <b-form-input type="text" v-model="appro.montant" placeholder="Montant de l'approvisionnement"></b-form-input>
            </b-col>
            <!-- <b-col md="6" v-if="display_atm">
              <label for="guichet_id">Guichet (*)</label>
              <b-form-select id="guichet_id" :plain="true" :options="options" v-model="appro.guichet_id">
              </b-form-select>
            </b-col> -->
            <b-col md="6" v-if="display_atm">
              <label for="guichet_id">Guichet *</label>
                <el-select style="display:block;"
                  v-model="appro.guichet_id" id="guichet_id"
                  loading-text="Chargement en cours"
                  no-match-text="Guichet non trouvé"
                  no-data-text="Aucune données trouvées"
                  size="small"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="Rechercher le nom de votre guichet"
                  :remote-method="remoteAgencies"
                  :loading="loading">
                  <el-option
                    v-for="item in options5"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value">
                  </el-option>
                </el-select>
            </b-col>
          </b-row>
          <div slot="footer">
            <span v-if="can('approvisionnement-list-by-guichet')"><b-button type="submit" size="sm" variant="primary" @click.prevent="post()"><i class="fa fa-dot-circle-o"></i> Valider</b-button></span>
            <b-button type="reset" @click="goBack" size="sm" variant="danger"><i class="fa fa-ban"></i> Annuler </b-button>
          </div>
        </b-card>    
    </b-col>
  </b-row>
</template>

<script>
import api from '../../../api/'
export default {
  name: 'tables',
  data(){
    return {
      dismissSecs: 10,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      response:{},
      options : [],
      display_atm :true,
      appro:{
            montant: '',
            guichet_id: ''
      },
      atm:[],
      serverParams: {
        page:1,
        current_page: 1,
        paginate: 10
      },
      options5: [],
      value9: [],
      list: [],
      loading: false,
      states: []
      
    }
  },
  methods:{
    goBack() {
        this.$router.go(-1)
    },
    countDownChanged (dismissCountDown) {
        this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    },
    async post(){    
         this.appro.montant = this.appro.montant.replace(/ /g, ''); 
         this.response = await this.$store.dispatch('appro/post_approvisionnementGuichet',this.appro)
         this.showAlert()
         
         if(this.response.success){
           this.reset()
           let solde = await api.entity.get_balance_entites(token)
           localStorage.setItem('solde', solde.data.data.solde)
           window.open(this.response.data.content, "_blank")
           setTimeout(function(){ location.reload(); }, 3000);
         }

    },
    async get_all_atms(){
        let serverParams = {
              page:1
        }
        if(this.$route.params.guichet_id === null || this.$route.params.guichet_id === 'null'){
          await this.$store.dispatch('atm/get_all_atms_own',serverParams).then(()=>{
            return this.atm = store.getters['atm/rows'];    
          })
          this.display_atm =true
          //this.atm =  store.getters['atm/rows'];
          this.atm.forEach((element)=>{
              console.log(element)
              this.options.push({
                value:element.id,
                text:element.agence_nom.toUpperCase()+' - '+element.nom.toUpperCase()
              })
          })
        }else{
            this.display_atm =false
            this.appro.guichet_id = this.$route.params.guichet_id
            this.options.push({
              value:this.$route.params.guichet_id,
              text:this.$route.params.guichet_id
            })
        }
    },
    get_all_approvisionnementguichet(){
        return this.rows =  store.getters['appro/rowsGuichet'];
    },
    can(perm){
        return store.getters['auth/can'](perm)
    },
    reset(){
        this.appro.montant= ''
    },
    remoteAgencies(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.options5 = this.options.filter(item => {
              return item.text.toLowerCase()
                .indexOf(query.toLowerCase()) > -1;
            });
          }, 200);
        } else {
          this.options5 = [];
        }
    }
  },
  mounted(){
    this.get_all_approvisionnementguichet()
    this.get_all_atms()
  }
}
</script>
